export enum ECompany {
  companies = 'company/getList',

  createConsultantCompany = 'company/consultantCompany',
  loadCompanyLogo = 'company/logo',
  searchCompanyByName = 'company/searchByName',
  checkCompanyByName = 'company/checkCompanyByName',
}
